import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MembershipBenefitsPageRoutingModule } from './membership-benefits-routing.module';

import { MembershipBenefitsPage } from './membership-benefits.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MembershipBenefitsPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [MembershipBenefitsPage],
})
export class MembershipBenefitsPageModule {}
